import { render, staticRenderFns } from "./TripSidebarDivider.vue?vue&type=template&id=b28bff68&scoped=true"
import script from "./TripSidebarDivider.vue?vue&type=script&lang=js"
export * from "./TripSidebarDivider.vue?vue&type=script&lang=js"
import style0 from "./TripSidebarDivider.vue?vue&type=style&index=0&id=b28bff68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28bff68",
  null
  
)

export default component.exports